import { hexKey, hexNeighbors } from "./hex.js";
import { getTileSetById, isOceanTileSet, resolveTileSetId } from "./tileCatalog.js";
const DIR_TO_EDGE = ["SE", "NE", "N", "NW", "SW", "S"];
// Edge → base asset direction + mirror flag
// Only N, NW, SW, S have dedicated assets; NE mirrors NW, SE mirrors SW
const EDGE_ASSET = {
    N: { assetDir: "N", mirrored: false },
    S: { assetDir: "S", mirrored: false },
    NW: { assetDir: "NW", mirrored: false },
    SW: { assetDir: "SW", mirrored: false },
    NE: { assetDir: "NW", mirrored: true },
    SE: { assetDir: "SW", mirrored: true },
};
// Available sizes per asset direction (excluding "big")
const AVAILABLE_SIZES = {
    N: ["small"],
    S: ["small"],
    NW: ["medium", "small"],
    SW: ["medium", "small"],
};
// Medium NW/SW overlays wrap toward adjacent edges — only safe if that edge is also land.
const WRAP_EDGE = {
    0: 5,
    1: 2,
    3: 2,
    4: 5,
};
function pickSize(assetDir, wrapEdgeIsLand) {
    const sizes = AVAILABLE_SIZES[assetDir];
    if (wrapEdgeIsLand) {
        return sizes[0];
    }
    return sizes[sizes.length - 1];
}
function coastFilename(size, direction) {
    return `Hex - Coast - Beach (${size}) ${direction}.png`;
}
export function getCoastOverlaysForHex(q, r, allHexes) {
    const key = hexKey({ q, r });
    const hex = allHexes[key];
    if (!hex)
        return [];
    const tileSetId = resolveTileSetId(hex);
    const group = tileSetId ? getTileSetById(tileSetId) : undefined;
    if (!group || !isOceanTileSet(group))
        return [];
    const neighbors = hexNeighbors({ q, r });
    const isLand = new Array(6);
    for (let i = 0; i < 6; i++) {
        const nKey = hexKey(neighbors[i]);
        const nHex = allHexes[nKey];
        if (!nHex) {
            isLand[i] = false;
            continue;
        }
        const neighborTileSetId = resolveTileSetId(nHex);
        const nGroup = neighborTileSetId ? getTileSetById(neighborTileSetId) : undefined;
        isLand[i] = nGroup ? !isOceanTileSet(nGroup) : false;
    }
    const results = [];
    for (let i = 0; i < 6; i++) {
        if (!isLand[i])
            continue;
        const edge = DIR_TO_EDGE[i];
        const { assetDir, mirrored } = EDGE_ASSET[edge];
        const wrapIdx = WRAP_EDGE[i];
        const wrapEdgeIsLand = wrapIdx !== undefined && isLand[wrapIdx];
        const size = pickSize(assetDir, wrapEdgeIsLand);
        results.push({ filename: coastFilename(size, assetDir), mirrored });
    }
    if (isLand[3] && isLand[4]) {
        results.push({
            filename: coastFilename("medium", "W"),
            mirrored: false,
        });
    }
    if (isLand[1] && isLand[0]) {
        results.push({
            filename: coastFilename("medium", "W"),
            mirrored: true,
        });
    }
    return results;
}
export function getAllCoastFilenames() {
    return [
        "Hex - Coast - Beach (medium) NW.png",
        "Hex - Coast - Beach (medium) SW.png",
        "Hex - Coast - Beach (medium) W.png",
        "Hex - Coast - Beach (small) N.png",
        "Hex - Coast - Beach (small) NW.png",
        "Hex - Coast - Beach (small) S.png",
        "Hex - Coast - Beach (small) SW.png",
    ];
}
